import { render, staticRenderFns } from "./IssueTicketsPerBooking.vue?vue&type=template&id=58d27623"
import script from "./IssueTicketsPerBooking.vue?vue&type=script&lang=js"
export * from "./IssueTicketsPerBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports